export default "__VITE_ASSET__BERzKTwY__"